import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { translation } from 'src/environments/translation';
import { TranslationService } from '../service/translation.service';

@Component({
  selector: 'app-item-startdate-popup',
  templateUrl: './item-startdate-popup.component.html',
  styleUrls: ['./item-startdate-popup.component.scss']
})
export class ItemStartdatePopupComponent implements OnInit {
  minDate: any;
  maxStartDate: any;
  // @ts-ignore
  itemForm: FormGroup;
  itemData: any;
translation:any;
  constructor(private translationService: TranslationService,private fb: FormBuilder,@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
    const translationAll = this.translationService.getAll(); 
    if (translationAll.en) {
      this.translation = translationAll.en;
    } 
    else {
      console.warn('English translations not found');
    }

    this.initForm();
    if (this.data) {
      this.itemData = this.data['rowData'];

      console.log('min start date', this.itemData['MinStartDate'])
      if (this.itemData['MinStartDate']) {
        this.minDate = moment(this.itemData['MinStartDate'], "YYYY-MM-DD").format("YYYY-MM-DD");
      }

      if (this.itemData['MaxStartDate']) {
        console.log('max start date', this.itemData['MaxStartDate'])
        this.maxStartDate = moment(this.itemData['MaxStartDate'], "YYYY-MM-DD").format("YYYY-MM-DD")

      }

      this.itemForm.get('ItemStartDate').setValue(this.itemData['MinStartDate'])
    }
  }

  get form() { return this.itemForm.controls }

  initForm() {
    this.itemForm = this.fb.group({
      ItemStartDate:[null, Validators.compose([Validators.required])]
    })
  }

  submit() {
    let updateData = {};
    if (this.itemForm.get('ItemStartDate').value) {
      updateData['ItemStartDate'] = moment(this.itemForm.get('ItemStartDate').value, "YYYY-MM-DD").format("YYYY-MM-DD");
    }
    else {
      updateData['ItemStartDate'] = null;
    }
    this.dialogRef.close(updateData);
  }
}
